import {
    Anchor,
    Box,
    Button,
    Center,
    Container,
    Group,
    Paper,
    PasswordInput,
    Stack,
    Title,
    rem,
} from '@mantine/core';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { matchesField, useForm } from '@mantine/form';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconArrowLeft } from '@tabler/icons-react';
import classes from './ForgotPassword.module.css';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { useEffect } from 'react';
import useResetPassword from '../../../http/mutations/auth/useResetPassword';

const ResetPassword = ({ ...props }) => {
    const [searchParams] = useSearchParams();
    const recoveryToken = searchParams.get('token');

    const { isPending, mutate: resetPassword } = useResetPassword();
    const form = useForm({
        initialValues: {
            password: '',
            confirmPassword: '',
        },

        validate: {
            password: (val) =>
                val.length <= 8
                    ? 'Password should include at least 8 characters'
                    : null,
            confirmPassword: matchesField('password', 'Password must match'),
        },
    });

    useEffect(() => {
        form.setFieldValue('recoveryToken', recoveryToken);
    }, [recoveryToken]);

    if (!recoveryToken) {
        // return <Navigate to={'/auth/login'} />;
    }

    const onSubmit = (model) => {
        resetPassword(model);
    };

    return (
        <Container
            size={460}
            my={30}>
            <Title
                className={classes.title}
                ta='center'>
                Reset your password
            </Title>
            <Paper
                withBorder
                shadow='md'
                p={30}
                radius='md'
                mt='xl'>
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Stack>
                        <PasswordInput
                            required
                            label='Password'
                            placeholder='New password'
                            radius='md'
                            {...form.getInputProps('password')}
                        />
                        <PasswordInput
                            required
                            label='Confirm Password'
                            placeholder='Re-type new password'
                            radius='md'
                            {...form.getInputProps('confirmPassword')}
                        />
                    </Stack>

                    <Group
                        justify='space-between'
                        mt='lg'
                        className={classes.controls}>
                        <Anchor
                            component={Link}
                            to={'/auth/login'}
                            className={classes.control}
                            c='dimmed'
                            size='sm'>
                            <Center inline>
                                <IconArrowLeft
                                    style={{ width: rem(12), height: rem(12) }}
                                    stroke={1.5}
                                />
                                <Box ml={5}>Back to the login page</Box>
                            </Center>
                        </Anchor>
                        <Button
                            type='submit'
                            className={classes.control}
                            disabled={isPending}
                            rightSection={
                                isPending ? (
                                    <FontAwesomeIcon
                                        icon={faSpinnerThird}
                                        spin
                                    />
                                ) : null
                            }>
                            Reset password
                        </Button>
                    </Group>
                </form>
            </Paper>
        </Container>
    );
};
export default ResetPassword;
